import { Button, cn } from "@qw/ui";
import type { ReactNode } from "react";

export interface EmptyStateAction {
  icon?: ReactNode;
  label: string;
  onClick: () => void;
}

export interface EmptyStateWithActionsProps {
  actions?: EmptyStateAction[];
  className?: string;
  description?: ReactNode;
  icon?: ReactNode;
  title?: string;
}

export const EmptyStateWithActions = ({ actions, className, description, icon, title }: EmptyStateWithActionsProps) => {
  const shouldCenterContent = Boolean(icon || title);

  return (
    <section className={cn("flex flex-auto flex-col gap-4", className)}>
      {icon ? <div className="shrink-0">{icon}</div> : null}
      {(title || description) && (
        <div className={cn("space-y-2", shouldCenterContent && "text-center")}>
          {title ? <h3 className="font-semibold">{title}</h3> : null}
          {description ? <div className="text-sm text-muted-foreground">{description}</div> : null}
        </div>
      )}

      {!!actions?.length && (
        <div className={cn("flex flex-wrap min-w-0 gap-2", shouldCenterContent && "justify-center")}>
          {actions.map((action) => (
            <Button
              key={action.label}
              variant="secondary"
              size="sm"
              onClick={action.onClick}
              title={action.label}
              className="min-w-0 max-w-full cursor-pointer"
            >
              {action.icon}
              <span className="truncate">{action.label}</span>
            </Button>
          ))}
        </div>
      )}
    </section>
  );
};
